export const getDropdownItems = (getDropdownItemsParams: {
  columnsKeys?: string[]
  setColumnsKeys?: (columnsKeys: string[]) => void
  setOpenColumnCreationModal: (openColumnCreationModal: boolean) => void
  setOpenBrandCreationModal: (openBrandCreationModal: boolean) => void
  setOpenCharacteristicCreationModal: (
    openCharacteristicCreationModal: boolean
  ) => void
  setOpenCategoryCreationModal: (openCategoryCreationModal: boolean) => void
  setOpenNomenclatureGroupCreationModal: (
    openNomenclatureGroupCreationModal: boolean
  ) => void
}) => {
  const {
    columnsKeys,
    setColumnsKeys,
    setOpenColumnCreationModal,
    setOpenBrandCreationModal,
    setOpenCharacteristicCreationModal,
    setOpenCategoryCreationModal,
    setOpenNomenclatureGroupCreationModal,
  } = getDropdownItemsParams

  const items = [
    {
      key: 'brandCreation',
      label: 'Добавить бренд',
      onClick: () => setOpenBrandCreationModal(true),
    },
    {
      key: 'characteristicCreation',
      label: 'Добавить характеристику',
      onClick: () => setOpenCharacteristicCreationModal(true),
    },
    {
      key: 'categoryCreation',
      label: 'Добавить категорию',
      onClick: () => setOpenCategoryCreationModal(true),
    },
    {
      key: 'nomenclatureGroupCreation',
      label: 'Добавить группу номенклатуры',
      onClick: () => setOpenNomenclatureGroupCreationModal(true),
    },
  ]

  if (columnsKeys && setColumnsKeys) {
    return [
      {
        key: 'columnCreation',
        label: 'Добавить колонку',
        onClick: () => setOpenColumnCreationModal(true),
      },
      ...items,
    ]
  }

  return items
}
